import actionTypes from "./actionTypes";
import api from "./api";
export default {
    saveAccessLevel: (accessLevel) => ({
        type: actionTypes.SAVE_ACCESS_LEVEL,
        payload: {
            promise: () => api.saveAccessLevel(accessLevel)
        },
        scope: `${actionTypes.SAVE_ACCESS_LEVEL}_${accessLevel.UserId}_${accessLevel.EntityType}_${accessLevel.EntityId}`
    }),
    deleteAccessLevel: (accessLevel) => ({
        type: actionTypes.DELETE_ACCESS_LEVEL,
        payload: {
            promise: () => api.deleteAccessLevel(accessLevel)
        },
        scope: `${actionTypes.DELETE_ACCESS_LEVEL}_${accessLevel.UserId}_${accessLevel.EntityType}_${accessLevel.EntityId}`
    }),
    setAccessLevelsKey: (accessLevelsKey) => ({
        type: actionTypes.SET_ACCESS_LEVEL_KEY,
        accessLevelsKey
    }),
    setAccessLevelNew: (accessLevelNew) => ({
        type: actionTypes.SET_ACCESS_LEVEL_NEW,
        accessLevelNew
    })
};
